import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import { Route, Routes } from 'react-router-dom'
import TeamPlanEditor from './components/TeamPlanEditor'
import TeamPlansOverview from './components/TeamPlansOverview'
import VisualPlanEditor from './components/visual_plans/VisualPlanEditor'
import PlanAbilityDefaultsPage from './components/PlanAbilityDefaultsPage'

const TeamPlans = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`Plans | ${team.name} | ${guild.name}`}>
      <Routes>
        <Route path='/' element={<TeamPlansOverview />} />
        <Route path='/visuals/:visualId' element={<VisualPlanEditor />} />
        <Route path='/ability-defaults' element={<PlanAbilityDefaultsPage />} />
        <Route path='/:planId' element={<TeamPlanEditor />} />
      </Routes>
    </Section>
  )
}

export default TeamPlans
